import { AfterViewInit, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { User } from '../../models/user';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { DynamicScriptLoaderService } from '../../services/dynamic-script-loader/dynamic-script-loader.service';

@Component({
  selector: 'app-dashboard',
  imports: [RouterModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit, AfterViewInit {
  currentUser!: User;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private dynamicScriptloader: DynamicScriptLoaderService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.authService.currentUser
      .asObservable()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({ next: (user) => (this.currentUser = user) });
  }

  ngAfterViewInit(): void {
    const scripts: string[] = ['assets/js/app.min.js'];

    this.dynamicScriptloader.loadScripts(scripts, document.head);
  }

  public logout(): void {
    this.authService.logout();
  }
}
